import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "@tanstack/react-router";
import { Content, Nav, SandboxedNav, Wrapper } from "./styled";
const AppLayout = ({ children, isSandboxedNav }) => (_jsxs(Wrapper, { children: [isSandboxedNav ? _jsx(SandboxedNav, {}) : _jsx(Nav, {}), _jsx(Content, { children: children !== null && children !== void 0 ? children : _jsx(Outlet, {}) })] }));
export default AppLayout;
